import {NavLink} from 'react-router-dom';
import styled from 'styled-components';

import {breakpoint, colors} from '@app/styles/theme';

export const RouterTabComponent = styled(NavLink)`
    font-style: normal;
    line-height: 20px;
    margin-bottom: 10px;
    word-wrap: break-word;
    white-space: nowrap;
    cursor: pointer;
    text-decoration: none;
    flex: 1;
    font-size: 13px;
    text-transform: uppercase;
    text-align: center;
    font-weight: bold;
    padding-bottom: 5px;
    border: none;
    border-bottom: 2px solid #e5e5e5;
    color: ${colors.textPrimary};
    transition: all ease 0.35s;

    &:focus {
        outline: none;
    }

    @media (max-width: ${breakpoint.tablet}) {
        padding: 0 10px 10px 5px;
    }
`;
